export const juniorEmbeddedEngineerResume = `
【職務概要】
組み込みソフトウェアエンジニアとして3年間、主に産業機器向けの制御システム開発に従事してきました。C/C++言語を用いたマイコン制御ファームウェア開発を専門とし、センサーデータの取得・処理からリアルタイム制御アルゴリズムの実装まで一連の開発工程を担当しています。特にROSを活用したロボット制御システムの構築において、モーター制御やセンサー入力処理に強みを持っています。

入社後は基本的な組み込みプログラミングスキルから始め、現在では要件定義から単体テスト、総合評価までを担当するまでに成長しました。プロジェクトでは仕様変更や予期せぬハードウェア制約に柔軟に対応し、常に納期と品質を両立させることを心がけています。IoTデバイスの普及やエッジコンピューティングの重要性が高まる中、RTOS（Real-Time Operating System）の活用や省電力設計などの技術習得にも積極的に取り組んでいます。

【職務経歴】
・株式会社Algomaticテクノロジー（2021年4月〜現在）
  ○ 会社概要：産業用IoT機器・制御システムの開発・製造（従業員約120名）
  ○ 就業期間：2021年4月〜現在
  ○ 職務内容：
    - 産業用制御装置のファームウェア開発（C/C++）
    - センサーデータ収集・処理モジュールの設計・実装
    - RTOSを活用したリアルタイム制御システムの開発
    - 通信プロトコル（UART, SPI, I2C等）の実装
  ○ 具体的な成果：
    - 生産ライン監視システムのファームウェア開発において、データ処理アルゴリズムを最適化し、処理速度を約30%向上
    - 温度センサーの誤差補正アルゴリズムを改良し、測定精度を±2.5%から±0.8%に向上
    - レガシーコードのリファクタリングによりメモリ使用量を20%削減
  ○ 使用した技術・ツール：
    - 言語：C, C++, Python（テスト自動化用）
    - マイコン：ARM Cortex-M4, Renesas RX
    - RTOS：FreeRTOS, μC/OS
    - 開発環境：IAR Embedded Workbench, Eclipse
    - バージョン管理：Git, SVN
  ○ 身につけたスキル：
    - リアルタイムシステム設計・実装技術
    - メモリ最適化・省電力設計手法
    - 組込みシステムのデバッグ技法
    - 製品品質保証プロセス

・株式会社Algomatic産業（2020年4月〜2021年3月）
  ○ 会社概要：電子部品・制御機器の受託開発・製造（従業員約50名）
  ○ 就業期間：2020年4月〜2021年3月
  ○ 職務内容：
    - 小型IoTデバイスのプロトタイプ開発
    - Arduino, Raspberry Piを使用した検証機の開発
    - センサーインターフェース開発
  ○ 具体的な成果：
    - 加速度センサーを用いた振動検知システムのプロトタイプ開発を担当し、予定より2週間早く完成
    - Bluetooth通信モジュールとの連携部分を実装し、通信エラー率を50%低減
  ○ 使用した技術・ツール：
    - 言語：C, C++, Python
    - プラットフォーム：Arduino, Raspberry Pi
    - 通信プロトコル：Bluetooth LE, Wi-Fi
  ○ 身につけたスキル：
    - 各種センサーの基本原理と活用方法
    - 無線通信技術の基礎
    - プロトタイピング手法

【受賞・表彰歴】
・2022年度 社内技術コンテスト 優秀賞受賞
  電力消費を最小限に抑えた無線センサーネットワークの設計で評価
・2023年 株式会社Algomaticテクノロジー社内表彰
  「若手エンジニア成長賞」受賞（自己啓発による技術力向上が評価）

【資格】
・2022年12月 組込みシステムスペシャリスト試験 合格
・2021年9月 情報処理技術者試験 基本情報技術者 合格
・2023年3月 TOEIC 720点

【マネジメント経験】
・新入社員1名の技術指導（2022年4月〜2022年9月）
  ○ C言語プログラミングの基礎からマイコン制御の実践的な技術まで指導
  ○ 新人が半年後に独立して業務を遂行できるレベルまで育成

【語学力】
・英語：ビジネス文書読解レベル
  ○ 技術仕様書や論文の読解、簡単な技術文書の作成が可能
  ○ TOEIC 720点（2023年3月取得）
  ○ 海外ベンダーとの技術情報交換のためのメールコミュニケーション経験あり
` as const;
